import { EventsProps } from "./Events"
import { ContentSummary, ContentSummaryVariant } from "common/components/ContentSummary"
import { imageSizes } from "common/lib/imageSizes"

/**
 * Component for displaying events
 */
export const EventsView = ({ events = [] }: EventsProps) => {
  return (
    <section className="mb-4">
      <div className="grid grid-cols-1 gap-4 sm:gap-6 md:grid-cols-2">
        {events.map(({ name, trackingUrl, byline, imageSrc }, index) => (
          <div key={index} className="flex justify-between gap-3 border-t border-gray-200 pt-4">
            <ContentSummary
              title={name}
              url={trackingUrl}
              byline={byline}
              image={{ src: imageSrc ? imageSrc : undefined }}
              variant={ContentSummaryVariant.BaseWide}
              imageSizes={imageSizes({ ratio: 0.125, mobileRatio: 0.25 })}
              imageFit="contain"
            />
          </div>
        ))}
      </div>
    </section>
  )
}
